import TourContainer from "../../components/bonusUi/tour";

const Tour = () => {
  return <TourContainer />;
};

export default Tour;
